import * as dotenv from 'dotenv'
const config = dotenv.config()

export default class VueRegister_serviceConfig {
	static getBaseURL() {
		 return process.env.BASE_URL;


	}
}
